import { createSelector } from 'reselect'

import { VALID_ACTIVITIES, VALID_ACTIVITIES_FOR_PANEL, NO_FLAG_ACTIVITIES, filterNotifications, getUnreadActivities, getNotificationsForProjects, getLastUserActivity, notificationIsUnread, getTaskNotifications } from '../utils/notification';

const getNonMessageNotificationsByAssociationId = (notifications, associationId) => filterNotifications(notifications, { associationId }).filter(notification => !notification.message_id);
export const makeGetNonMessageNotificationsByAssociationId = () => createSelector(getNonMessageNotificationsByAssociationId, notifications => notifications);

const getProjectNotificationsByType = (notifications, projectId, type) => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.project &&
        notification.project.id === projectId &&
        notification.type === type
    );
export const makeGetProjectNotificationsByType = () => createSelector(getProjectNotificationsByType, notifications => notifications);

export const getNotificationsByAssociationId = (notifications, associationId) => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.association &&
        notification.association.id === associationId
    );
export const makeGetNotificationsByAssociationId = () => createSelector(getNotificationsByAssociationId, notifications => notifications);

const getMessageNotificationsByAssociationId = (notifications, associationId) => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.association &&
        notification.association.message_id &&
        notification.association.id === associationId
    );
export const makeGetMessageNotificationsByAssociationId = () => createSelector(getMessageNotificationsByAssociationId, notifications => notifications);

const getTeamMessageNotifications = notifications => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        notification.association &&
        notification.association.message_id &&
        !notification.project
    );
export const makeGetTeamMessageNotifications = () => createSelector(getTeamMessageNotifications, notifications => notifications);

export const makeGetTaskNotifications = () => createSelector(getTaskNotifications, notifications => notifications);

const getNotificationsByType = (notifications, type) => filterNotifications(notifications, { type });
export const makeGetNotificationsByType = () => createSelector(getNotificationsByType, notifications => notifications);

const getProjectTaskNotificationsByTaskIds = (notifications, projectId, tasksIds) =>
    filterNotifications([
        ...getProjectNotificationsByType(notifications, projectId, 'task'),
        ...getProjectNotificationsByType(notifications, projectId, 'subtask')
    ], { tasksIds })
    .filter(notification => !NO_FLAG_ACTIVITIES.includes(`${notification.type}.${notification.action}`));
export const makeGetProjectTaskNotificationsByTaskIds = () => createSelector(getProjectTaskNotificationsByTaskIds, notifications => notifications);

const getAllNotificationsByTriggeredBy = (notifications, triggeredBy) => notifications
    .filter(notification =>
        notification &&
        VALID_ACTIVITIES.includes(`${notification.type}.${notification.action}`) &&
        notification.triggered_by && notification.triggered_by.id === triggeredBy
    );
export const makeGetAllNotificationsByTriggeredBy = () => createSelector(getAllNotificationsByTriggeredBy, notifications => notifications);

const getSortedPanelNotifications = notifications => notifications
    .filter(notification =>
        notification &&
        VALID_ACTIVITIES_FOR_PANEL.includes(`${notification.type}.${notification.action}`)
    )
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
export const makeGetSortedPanelNotifications = () => createSelector(getSortedPanelNotifications, notifications => notifications);

const getPanelNotificationsCount = notifications => notifications
    .filter(notification =>
        notificationIsUnread(notification) &&
        VALID_ACTIVITIES_FOR_PANEL.includes(`${notification.type}.${notification.action}`)
    ).length;
export const makeGetPanelNotificationsCount = () => createSelector(getPanelNotificationsCount, notificationsCount => notificationsCount);

const getUnreadNotificationsByTypeAndAction = (notifications, typesAndActions) => notifications
    .filter(notification => notificationIsUnread(notification) && typesAndActions.includes(`${notification.type}.${notification.action}`));
export const makeGetUnreadNotificationsByTypeAndAction = () => createSelector(getUnreadNotificationsByTypeAndAction, notifications => notifications);

const getUnreadNotificationsByAssociationType = (notifications, associationType) => notifications
    .filter(notification => notificationIsUnread(notification) && notification.association && notification.association.type === associationType);
export const makeGetUnreadNotificationsByAssociationType = () => createSelector(getUnreadNotificationsByAssociationType, notifications => notifications);

export const makeGetUnreadActivities = () => createSelector(getUnreadActivities, notifications => notifications);

const getUnreadNotifications = notifications => notifications.filter(notificationIsUnread);
export const makeGetUnreadNotifications = () => createSelector(getUnreadNotifications, notifications => notifications);

const getNotificationsForProject = (notifications, projectId) => getNotificationsForProjects(notifications, [projectId]);
export const makeGetNotificationsForProject = () => createSelector(getNotificationsForProject, notifications => notifications);

const getProjectNotificationsForSubteam = (notifications, projects, subteamId) => getNotificationsForProjects(notifications, projects.filter(project => project.subteam === subteamId).map(p => p.id));
export const makeGetProjectNotificationsForSubteam = () => createSelector(getProjectNotificationsForSubteam, notifications => notifications);

export const makeGetLastUserActivity = () => createSelector(getLastUserActivity, notifications => notifications);
